import { Globe, Megaphone, PenTool, MapPin, Search, Palette, ArrowUpRight } from "lucide-react";
import { Reveal, SectionTag, SectionHeading } from "@/components/landing/Reveal";
import { scrollToId } from "@/lib/scroll";
import { useLang } from "@/lib/i18n";

export const SERVICE_ICONS = {
  globe: Globe,
  pentool: PenTool,
  mappin: MapPin,
  megaphone: Megaphone,
  search: Search,
  palette: Palette,
};

export default function Services({ services }) {
  const { t, dyn } = useLang();
  return (
    <section id="tjanster" data-testid="services-section" className="bg-coal py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionTag number="02" label={t("services.tag")} />
        <div className="grid gap-10 lg:grid-cols-2 lg:items-end">
          <SectionHeading>{t("services.heading")}</SectionHeading>
          <Reveal delay={0.15}>
            <p className="max-w-md text-base leading-relaxed text-fog lg:ml-auto">
              {t("services.sub")}
            </p>
          </Reveal>
        </div>
        <div className="mt-16 grid gap-6 md:grid-cols-2">
          {services.map((service, i) => {
            const Icon = SERVICE_ICONS[service.icon] || Globe;
            return (
              <Reveal key={`${service.title}-${i}`} delay={0.08 + i * 0.1}>
                <article
                  data-testid={`service-card-${i}`}
                  className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-surface p-8 transition-all duration-500 hover:-translate-y-1 hover:border-mint/40 hover:shadow-[0_20px_60px_-20px_rgba(22,78,61,0.5)] sm:p-10"
                >
                  <div className="flex items-start justify-between">
                    <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-ink text-mint transition-colors duration-500 group-hover:border-mint/40">
                      <Icon className="h-5 w-5" />
                    </div>
                    <span className="font-mono text-xs text-fog">0{i + 1}</span>
                  </div>
                  <h3 className="mt-8 font-display text-xl font-bold tracking-tight text-bone sm:text-2xl">
                    {dyn(service.title)}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-fog sm:text-base">
                    {dyn(service.description)}
                  </p>
                  <button
                    data-testid={`service-cta-${i}`}
                    onClick={() => scrollToId("#boka")}
                    className="mt-8 flex items-center gap-2 text-sm font-semibold text-mint opacity-0 transition-all duration-500 group-hover:opacity-100"
                  >
                    {t("services.cta")}
                    <ArrowUpRight className="h-4 w-4" />
                  </button>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
